import { Controller } from '@hotwired/stimulus'
import HubSpotContactForm from "components/hubspot/contact_form"
import { waitForQuimbeeDataKey } from 'controllers/quimbee_data_controller'
import Quimbee from 'quimbee'

export default class extends Controller {
  async initialize() {
    const hubSpotContactForm = new HubSpotContactForm()

    await waitForQuimbeeDataKey("hubSpotForms")

    hubSpotContactForm.initialize(
      Quimbee.data.hubSpotForms.billMyEmployerFormId.internal_id,
      `#${this.element.id}`
    )
  }
}
